<template>
    <app-layout :title="trans('bookings.page_title.calendar')">
        <template #header>
            {{ trans("bookings.page_title.calendar") }}
        </template>

        <Section>
            <Container>
                <FullCalendar :options="calendarOptions" />
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import StyledButton from "@/Components/StyledButton.vue";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import deLocale from "@fullcalendar/core/locales/de";

export default {
    components: {
        AppLayout,
        Link,
        Container,
        Section,
        StyledButton,
        FullCalendar,
    },

    props: {
        bookings: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                initialView: "timeGridWeek",
                locale: deLocale,
                businessHours: {
                    daysOfWeek: [1, 2, 3, 4, 5, 6],
                    startTime: "09:30",
                    endTime: "19:00",
                },
                nowIndicator: true,
                events: this.bookings["data"],
            },
        };
    },
};
</script>
